import { SocialIcons } from "../../../components";

interface CopyrightProps {
  variant?: string;
}

export default function Copyright({ variant }: CopyrightProps) {
  return (
    <div
      className={`flex flex-col sm:flex-row flex-wrap items-center justify-center sm:justify-between gap-3 pt-5 mt-10 border-t w-full text-center sm:text-left ${
        variant === "light" ? "border-neutral-200" : "border-neutral-900"
      }`}
    >
      <p
        className={`${
          variant === "light" ? "text-gray-600" : "text-gray-300"
        } text-sm`}
      >
        &copy; Copyright Delta Mortgages 2024 - All Rights Reserved
      </p>
      <p
        className={`${
          variant === "light" ? "text-gray-600" : "text-gray-300"
        } text-sm`}
      >
        Developed by{" "}
        <a
          href="https://www.devmindpro.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-cred-100 underline"
        >
          Devmindpro
        </a>
      </p>
      <div>
        <SocialIcons
          normalBg="bg-transparent"
          hoverBg=""
          normalText="text-gray-300"
          hoverText="text-cred-100"
        />
      </div>
    </div>
  );
}
